import React from "react";
import HeaderNav from "../components/HeaderNav";
import "./NewApplicant.css";
import { GoogleForm } from "../components/GoogleForm";

const NewApplicant = () => {
  return (
    <div className="newapp">
      <HeaderNav />
      <div className="newapp__container">
        <GoogleForm />
      </div>
    </div>
  );
};

export default NewApplicant;
